import React, { useEffect, useState } from "react";
import { ChevronRight, ArrowDown } from "lucide-react";
import { HERO_SLIDES, LINKS } from "../mock/data";

export default function Hero() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const t = setInterval(() => {
      setIndex((i) => (i + 1) % HERO_SLIDES.length);
    }, 6000);
    return () => clearInterval(t);
  }, []);

  const slide = HERO_SLIDES[index];

  return (
    <section id="home" className="relative h-screen min-h-[640px] w-full overflow-hidden">
      {/* Background slides */}
      {HERO_SLIDES.map((s, i) => (
        <div
          key={s.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            i === index ? "opacity-100" : "opacity-0"
          }`}
        >
          <img
            src={s.image}
            alt={s.title}
            className={`w-full h-full object-cover ${i === index ? "animate-kenburns" : ""}`}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-black/50 to-black/40" />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-transparent" />
        </div>
      ))}

      {/* Content */}
      <div className="relative z-10 h-full max-w-[1400px] mx-auto px-5 md:px-8 flex flex-col justify-center">
        <div key={slide.id} className="max-w-3xl">
          <div className="flex items-center gap-3 mb-5 reveal in-view">
            <span className="h-[2px] w-10 bg-baja-red" />
            <span className="font-cond uppercase tracking-[0.25em] text-sm text-white/80">
              {slide.tag}
            </span>
          </div>
          <h1 className="font-display text-6xl sm:text-7xl md:text-8xl lg:text-9xl uppercase leading-[0.9] text-white">
            {slide.title}
          </h1>
          <p className="mt-6 text-lg md:text-xl text-white/75 max-w-xl font-400 leading-relaxed">
            {slide.subtitle}
          </p>
          <div className="mt-9 flex flex-wrap items-center gap-4">
            <a
              href={LINKS.shop}
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-baja-red hover:bg-[#ff1a44] transition-colors text-white font-cond font-600 uppercase tracking-wider px-8 py-4 flex items-center gap-2 text-lg"
            >
              Shop The Range
              <ChevronRight size={20} className="group-hover:translate-x-1 transition-transform" />
            </a>
            <a
              href="#automotive"
              className="border border-white/40 hover:border-white text-white font-cond uppercase tracking-wider px-8 py-4 text-lg transition-colors hover:bg-white/5"
            >
              Explore Products
            </a>
          </div>
        </div>
      </div>

      {/* Slide indicators */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex items-center gap-3">
        {HERO_SLIDES.map((s, i) => (
          <button
            key={s.id}
            onClick={() => setIndex(i)}
            aria-label={`Slide ${i + 1}`}
            className={`h-[3px] transition-all duration-300 ${
              i === index ? "w-10 bg-baja-red" : "w-5 bg-white/40 hover:bg-white/70"
            }`}
          />
        ))}
      </div>

      <div className="absolute bottom-8 right-8 z-10 hidden md:flex flex-col items-center gap-2 text-white/60">
        <span className="font-cond uppercase text-xs tracking-widest rotate-90 origin-center mb-6">Scroll</span>
        <ArrowDown size={18} className="animate-bounce" />
      </div>
    </section>
  );
}
